<template>
  <div
    ref="slider"
    class="relative pt-4 px-4 md:px-8 lg:px-16"
    :class="[
      { 'pl-4 pr-8': !isMobile }
    ]"
  >
    <div
      class="swiper-wrapper flex"
      v-html="slotContent"
    />

    <div
      class="swiper-pagination mt-8"
      :class="{
        'md:hidden': !showPaginationOnDesktop || items.length < 2
      }"
    />

    <button
      v-show="isPagingVisibleOnDesktop"
      class="invisible md:visible swiper-button-prev"
    >
      <div class="flex items-center relative w-full h-full justify-center">
        <span class="icon-chevron-left relative z-20" />
      </div>
    </button>
    <button
      v-show="isPagingVisibleOnDesktop"
      class="invisible md:visible swiper-button-next"
    >
      <div class="flex items-center relative w-full h-full justify-center">
        <span class="icon-chevron-right relative z-20" />
      </div>
    </button>
  </div>
</template>

<script>
// TODO Import swiper and only required modules
import Swiper from 'swiper/bundle'
import tracking from '@/helpers/tracking'

export default {
  props: {
    items: {
      type: Array,
      required: true
    },
    sliderTitle: {
      type: String,
      required: true
    },
    slotContent: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: ''
    },
    slidesPerView: {
      type: Number,
      default: 1
    },
    showPaginationOnDesktop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isMobile: window.matchMedia('(max-width: 767px)').matches
    }
  },
  computed: {
    isPagingVisibleOnDesktop() {
      return !this.isMobile && this.items.length > 4
    }
  },
  mounted() {
    this.initializeSlider()
    this.addTracking()
    const recipes = this.$refs.slider.querySelectorAll('.recipe-card')
    if (recipes.length) {
      this.$refs.slider.classList += ' recipes-carousel'
    }
  },
  methods: {
    addTracking() {
      this.$refs.slider.querySelectorAll('a').forEach((item) => {
        const recipeName = item.dataset.trackingTitle
        item.addEventListener('click', () => {
          this.onItemClick(recipeName)
        })
      })
    },
    onItemClick(sliderItemTitle) {
      tracking.facetSliderClick({
        sliderTitle: this.sliderTitle,
        sliderItemTitle,
        placement: this.placement
      })
    },
    initializeSlider() {
      const settings = {
        initialSlide: 0,
        grabCursor: this.items.length > 1,
        slidesPerView: this.slidesPerView,
        spaceBetween: 24,
        pagination: {
          el: '.swiper-pagination'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          768: {
            grabCursor: this.items.length > 4,
            slidesPerView: 4
          }
        }
      }

      this.slider = new Swiper(this.$refs.slider, settings)

      this.slider.on('slideChange', () => {
        tracking.sliderScroll({
          interactionType: (this.slider.swipeDirection === undefined) ? 'click' : 'swipe',
          sliderTitle: this.sliderTitle,
          direction: (this.slider.activeIndex > this.slider.previousIndex) ? 'right' : 'left',
          placement: this.placement
        })
      })
    }
  }
}
</script>
